"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Software = function Software(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/products/software-software" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "combined-shape-software" + unique,
    xlinkHref: "#path-1-software" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-software" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4,3 L20,3 C20.5522847,3 21,3.44771525 21,4 L21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 Z M5.35355339,15.1464466 L6.06066017,15.8535534 C6.25592232,16.0488155 6.57250481,16.0488155 6.76776695,15.8535534 L10.267767,12.3535534 C10.4630291,12.1582912 10.4630291,11.8417088 10.267767,11.6464466 L6.76776695,8.14644661 C6.57250481,7.95118446 6.25592232,7.95118446 6.06066017,8.14644661 L5.35355339,8.85355339 C5.15829124,9.04881554 5.15829124,9.36539803 5.35355339,9.56066017 L7.79289322,12 L5.35355339,14.4393398 C5.15829124,14.634602 5.15829124,14.9511845 5.35355339,15.1464466 Z M12.5,14 C12.2238576,14 12,14.2238576 12,14.5 L12,15.5 C12,15.7761424 12.2238576,16 12.5,16 L18.5,16 C18.7761424,16 19,15.7761424 19,15.5 L19,14.5 C19,14.2238576 18.7761424,14 18.5,14 L12.5,14 Z",
    fill: "inherit",
    id: "path-1-software" + unique
  }))));
};

Software.propTypes = propTypes;
var _default = Software;
exports["default"] = _default;